module.exports = {
	siteName: 'store',
	site: {
		mancity: {},
	},
};
